import {Stack, Typography, Divider} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import HasBenchmarkDisplay from "./HasBenchmarkDisplay";

export default function EvaluationDisplay(props) {
  const {mappings, defaultLanguage, objList, normalizeBreaks, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }
  if (!objList || objList.length === 0 || objList.every((item) => item.isEmpty?.() ?? true)) return null;

  return (
    <>
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      <Stack sx={{pb: 2}} spacing={1}>
        {objList.map((item, index) => {
          const isLastElement = index === objList.length - 1;
          return (
            <div key={index}>
              {item.hasBenchmarkList && item.hasBenchmarkList.length>0 && (
                <div>
                  <HasBenchmarkDisplay
                    objList={item.hasBenchmarkList}
                    defaultLanguage={defaultLanguage}
                    mappings={mappings}
                    normalizeBreaks={normalizeBreaks}
                    topLabel={getLabel(keys.hasBenchmark, "hasBenchmark")}
                  />
                </div>
              )}
              <Stack spacing={2} sx={{pt: 2}}>
                {item.evaluationOutput && !isEmpty(item.evaluationOutput.getValue(defaultLanguage)) && (
                  <div>
                    <Typography variant="body2" className={"key"}>{getLabel(keys.evaluationOutput, "evaluationOutput")}</Typography>
                    <Typography variant="body1">{item.evaluationOutput.getValue(defaultLanguage)}</Typography>
                  </div>
                )}

                {item.metric && !isEmpty(item.metric.getValue(defaultLanguage)) && (
                  <div>
                    <Typography variant="body2" className={"key"}>{getLabel(keys.metric, "metric")}</Typography>
                    <Typography variant="body1">{item.metric.getValue(defaultLanguage)}</Typography>
                  </div>
                )}

                {item.task && !isEmpty(item.task.getValue(defaultLanguage)) && (
                  <div>
                    <Typography variant="body2" className={"key"}>{getLabel(keys.task, "task")}</Typography>
                    <Typography variant="body1">{item.task.getValue(defaultLanguage)}</Typography>
                  </div>
                )}
              </Stack>

              <Divider component="div" role="presentation" className={`dashed ${ isLastElement ? "hide-divider" : ""}`}/>
            </div>
          );
        })}
      </Stack>
    </>
  );
}
